// review slider
const reviewTotalSlides = document.querySelectorAll('#review-slider .swiper-slide').length;
const reviewTotalGroups = Math.ceil(reviewTotalSlides / 3);
const reviewPaginationEl = document.querySelector('.review-swiper__pagination');

function updateReviewDots(swiper) {
    if (!reviewPaginationEl) return;
    const groupIndex = Math.floor(swiper.realIndex / 3);
    reviewPaginationEl.querySelectorAll('.review-dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === groupIndex);
    });
}

const reviewSwiper = new Swiper('#review-slider .review-swiper', {
    loop: true,
    grabCursor: true,
    navigation: {
        nextEl: '.review-swiper__next',
        prevEl: '.review-swiper__prev',
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 16,
            slidesPerGroup: 1,
        },
        769: {
            slidesPerView: 3,
            spaceBetween: 24,
            slidesPerGroup: 1,
        },
    },
    on: {
        slideChange: function () {
            var fraction = document.querySelector('.review-swiper__fraction');
            if (fraction) {
                fraction.textContent = (this.realIndex + 1) + '/' + reviewTotalSlides;
            }
            updateReviewDots(this);
        },
    },
});

// Build custom pagination dots
if (reviewPaginationEl) {
    reviewPaginationEl.innerHTML = Array.from({ length: reviewTotalGroups }, function (_, i) {
        return '<span class="review-dot' + (i === 0 ? ' is-active' : '') + '"></span>';
    }).join('');

    reviewPaginationEl.addEventListener('click', function (e) {
        if (e.target.classList.contains('review-dot')) {
            var dots = Array.from(reviewPaginationEl.querySelectorAll('.review-dot'));
            reviewSwiper.slideToLoop(dots.indexOf(e.target) * 3);
        }
    });
}

document.querySelector('.review-swiper__sp-prev').addEventListener('click', function () { reviewSwiper.slidePrev(); });
document.querySelector('.review-swiper__sp-next').addEventListener('click', function () { reviewSwiper.slideNext(); });

// equalize review card heights
function equalizeReviewTitles() {
    const titles = document.querySelectorAll('#review-slider .review-card__title');
    titles.forEach(t => t.style.minHeight = 'auto');
    let maxH = 0;
    titles.forEach(t => { maxH = Math.max(maxH, t.offsetHeight); });
    titles.forEach(t => t.style.minHeight = maxH + 'px');
}

function equalizeReviewCards() {
    const cards = document.querySelectorAll('#review-slider .review-card');
    cards.forEach(c => c.style.height = 'auto');
    let maxH = 0;
    cards.forEach(c => { maxH = Math.max(maxH, c.offsetHeight); });
    cards.forEach(c => c.style.height = maxH + 'px');
}

function runReviewEqualize() {
    equalizeReviewTitles();
    equalizeReviewCards();
}

if (document.readyState === 'complete') {
    runReviewEqualize();
} else {
    window.addEventListener('load', runReviewEqualize);
}
window.addEventListener('resize', runReviewEqualize);

// testimonials
const soundSwiper = new Swiper('#testimonials .swiper', {
spaceBetween: 170,
grabCursor: true,
slidesPerView: 1,
loop: true,
pagination: {
    el: '.swiper-pagination',
    clickable: true,
},
navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
},

})


// product
document.addEventListener('DOMContentLoaded', function () {

  const buttons  = document.querySelectorAll('.color__button');
  const images   = document.querySelectorAll('.product__item');
  const ctaLinks = document.querySelectorAll('.cta__link');

  buttons.forEach((button, index) => {

    button.addEventListener('click', function () {

      const key = button.getAttribute('data');

      /* ===== 画像切替 ===== */
      images.forEach(img => img.classList.remove('is-active'));
      images[index].classList.add('is-active');

      /* ===== CTA切替 ===== */
      ctaLinks.forEach(link => {
        link.classList.remove('is-active');

        if (link.getAttribute('data-target') === key) {
          link.classList.add('is-active');
        }
      });

      /* ===== ボタンactive ===== */
      buttons.forEach(btn => btn.classList.remove('is-active'));
      button.classList.add('is-active');

    });

  });

});


//floating banner
document.addEventListener('DOMContentLoaded', function () {

  const floating = document.querySelector('.floating-container');
  const closeBtn = document.querySelector('.close-btn');
  const footer   = document.querySelector('footer');

  if (!floating) return;

  let isClosed = false;
  let isFooterVisible = false;


  function updateFloating() {

    if (isClosed || isFooterVisible) {
      floating.classList.remove('is-active');
      return;
    }

    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      if (window.scrollY > 1000) {
        floating.classList.add('is-active');
      } else {
        floating.classList.remove('is-active');
      }
    } else {
 
      floating.classList.add('is-active');
    }
  }


  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      isClosed = true;
      floating.classList.remove('is-active');
    });
  }


  if (footer) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        isFooterVisible = entry.isIntersecting;
        updateFloating();
      });
    });

    observer.observe(footer);
  }

  window.addEventListener('scroll', updateFloating);
  window.addEventListener('resize', updateFloating);

  updateFloating();

});